(function ($) {
  $(document).ready(function () {
    var recipeTitles = $('.recipe-title');

    if (recipeTitles.length) {
      var height = 0;

      recipeTitles.each(function () {
        var currTitleHeight = $(this).outerHeight();

        if (currTitleHeight > height) {
          height = currTitleHeight;
        }
      });

      recipeTitles.css('min-height', height);
    }

    var sliderSection = $('.slider-section');

    if (sliderSection.length) {
      var owl = $('.owl-carousel');

      owl.owlCarousel({
        dots: false,
        items: 1,
        loop: true,
        autoplay: true,
        autoplayTimeout: 5000,
        responsive: {
          1200: {
            dots: true
          }
        },
        onInitialized: function (event) {
          var items = event.item.count;

          if (items <= 1) {
            owl.find('.owl-stage').addClass('single');
          }
        }
      });
    }

    if ($('.product-items-section').length) {
      $('.product-item').on('click', function () {
        $(this).find('.product-popup').toggleClass('active');
      });

      $('.close-popup-btn').on('click', function () {
        var productPopup = $(this).closest('[product-js]').find('.product-popup');

        console.log(productPopup);

        productPopup.removeClass('active');
      });
    }

    if ($('.recipes-posts, .page-template-template-recipes').length) {
      var animateSpeed = 450;

      $('button.read-more').on('click', function () {
        var $postExcerpt = $(this).closest('.post-excerpt');
        var $postContent = $postExcerpt.find('.content');
        var $postExcerptContent = $postExcerpt.find('.excerpt');

        $postContent.css('height', 'auto');

        var $postContentHeight = $postContent.outerHeight();

        $postExcerptContent.animate({
          height: 0
        }, animateSpeed);

        $postContent
          .css('height', 0)
          .animate({
            height: $postContentHeight
          }, animateSpeed);
      });

      $('button.read-less').on('click', function () {
        var $postExcerpt = $(this).closest('.post-excerpt');
        var $postContent = $postExcerpt.find('.content');
        var $postExcerptContent = $postExcerpt.find('.excerpt');

        $postExcerptContent.css('height', 'auto');

        var $postExcerptContentHeight = $postExcerptContent.outerHeight();

        $postContent.animate({
          height: 0
        }, animateSpeed);

        $postExcerptContent
          .css('height', 0)
          .animate({
            height: $postExcerptContentHeight
          }, animateSpeed);
      });
    }

    if ($('#pdf').length) {
      $('[js-print]').on('click', function () {
        window.print();
      });
    }

    $('a[href^="#"]').on('click', function (e) {
      e.preventDefault();

      $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top - $('.header').outerHeight()
      }, 500);
    });

    $('.click-more').on('click', function () {
      $(this).hide();
      $('.show-more').show();
    });

    $(document).on('wheel', 'input[type=number]', function (e) {
      $(this).blur();
    });

    // $(".wpcf7-date").datepicker();
  });
})(jQuery);
